import type { LabelValue } from "newui/types/LabelValue.type";
import type { CommonLookupResponse } from "newui/store/tanstack-base";
import { useCommonLookup } from "newui/store/tanstack-base";
import { fetchCompanySizes } from "../company-api";
import { CompanySizeFetchParams } from "../types/CompanyInformationForm.type";

export const useCompanySizes = (
	profileType?: number,
	showAllOption = true
): CommonLookupResponse<LabelValue<number>> => {
	return useCommonLookup<LabelValue<number>, CompanySizeFetchParams>(
		`companySizes-${profileType ?? "all"}`,
		fetchCompanySizes,
		{ profileType, showAllOption } as CompanySizeFetchParams
	);
};
